import styled from 'styled-components';

const MultiSelectInputStyled = styled.input`
    border: none;
    font-size: 16px;
    font-weight: 600;
    height: 40px;

    &:focus {
        outline: none;
    }   
`;

export default MultiSelectInputStyled;